function modal() {
  // otevření okna
  Array.from(document.getElementsByClassName('js-modal-open')).forEach((element) => {
    element.addEventListener('click', function (event) {
      event.preventDefault(); // Zabrání přesměrování
      let href = this.getAttribute('href');

      // kontrola, zda href není null
      if (href) {
        let modalName = href.substring(1); // Odstraní "#" z href

        // otevření okna
        let modalElement = document.getElementById(modalName);
        if (modalElement) {
          modalElement.classList.add('is-open');
          document.body.classList.add('is-unscrollable');
        }
      }
    });
  });

  // zavření modal okna
  Array.from(document.getElementsByClassName('js-modal-close')).forEach((element) => {
    element.addEventListener('click', function (event) {
      event.preventDefault();
      this.closest('.modal').classList.remove('is-open');
      document.body.classList.remove('is-unscrollable');
    });
  });

  // zavření okna kliknutím na pozadí
  Array.from(document.getElementsByClassName('modal')).forEach((element) => {
    element.addEventListener('click', function (event) {
      event.preventDefault();
      this.classList.remove('is-open');
      document.body.classList.remove('is-unscrollable');
    });
  });

  // zamezení zavření po kliknutí na tělo modalu
  Array.from(document.getElementsByClassName('modal__body')).forEach((element) => {
    element.addEventListener('click', function (event) {
      event.stopPropagation();
    });
  });
}
